(ns ductile.ui.websocket
  (:require [cljs.core.async :as async :refer [<!]]
            [ductile.clerk.viewer :as v]
            [ductile.ui.deframe :as deframe]
            [ductile.ui.transit :as ductile-transit]
            [ductile.ui.util :as util]
            [nextjournal.log :as log]
            [taoensso.sente :as sente]
            [taoensso.sente.packers.transit :as sente-transit])
  (:require-macros [cljs.core.async.macros :as asyncm :refer [go-loop]]))

(defonce !channel (atom nil))

(defmulti handle-ws-event (comp first :event))
(defmulti handle-event first)

(defmethod handle-ws-event :default [{:keys [event]}]
  (log/warn :unhandled-ws-event event))

(defmethod handle-event :default [event]
  (log/debug :unhandled-event event))

(defmethod handle-ws-event :chsk/state [{:keys [event]}]
  (let [[_ [old new]] event
        changed (remove #(= (get old %) (get new %)) (into #{} (concat (keys new) (keys old))))]
    (log/trace :state-changed
               (into {}
                     (map
                      (fn [k]
                        [k (list (get old k) '-> (get new k))]))
                     changed))))

(defn get-send-fn [system]
  (or (:send-fn (:ductile.ui.websocket/client system))
      (throw (ex-info "cannot get `send-fn` from system" {:system system}))))

#_(disable-speculative-transactions! (get-send-fn @ductile.ui.system/system))


(defonce !pending-replies
  (atom {}))

(defmethod handle-event :lambda/reply [event]
  (let [[_ {:as reply :keys [reply-id result]}] event]
    (when-let [{:keys [resolve reject]} (get @!pending-replies reply-id)]
      (resolve result)
      (swap! !pending-replies dissoc reply-id))))

(defn $lambda [handler-sym opts]
  (let [reply-id (gensym)
        promise (js/Promise. (fn [resolve reject]
                               (swap! !pending-replies assoc reply-id {:resolve resolve :reject reject})))]
    (log/debug :$lambda opts)
    ((get-send-fn @@(resolve 'ductile.ui.system/system)) [:lambda/call {:handler-sym handler-sym :reply-id reply-id :params opts}])
    promise))

(defmethod handle-ws-event :chsk/handshake [{:keys [event send-fn]}]
  (let [[_ [uid]] event]
    (log/trace :handshake {:uid uid})
    (send-fn [:ductile/websocket-client-hello {:ductile.ui.hashing/front-end-hash @(deframe/!get :ductile.ui.hashing/front-end-hash)}])))

(defmethod handle-ws-event :chsk/recv [{:keys [event]}]
  (let [[_ app-level-event] event]
    (log/trace :chsk/recv event)
    (handle-event app-level-event)))

(defmethod handle-event :chsk/ws-ping [event]
  (log/trace :chsk/ws-ping true))

(defmethod handle-event :client/reload [[_ params :as sync-result]]
  (deframe/dispatch! `ductile.ui/attempt-reload params))

(defmethod handle-event :client/refetch [[_ params :as sync-result]]
  (deframe/route-refetch!))

(when v/dev?
  (defmethod handle-event :client/eval-cljs [[_ form]]
    ((resolve 'ductile.clerk.sci-env-ext/eval-sci) (pr-str form))))

(defn start-event-loop! [{:as client :keys [chsk ch-recv send-fn state]}]
  (go-loop [evt (<! ch-recv)]
    (try
      (handle-ws-event evt)
      (catch js/Error error
        (log/error :event-loop-error error :event evt)))
    (recur (<! ch-recv))))

(defn make-ws-client [host]
  (sente/make-channel-socket-client!
   (str host "/ws")
   (util/csrf-token)
   {:type :ws
    :wrap-recv-evs?
    true
    :packer (sente-transit/->TransitPacker
             :json
             {:handlers @ductile-transit/write-handlers}
             {:handlers @ductile-transit/read-handlers})}))

(defn connect []
  (reset! !channel (start-event-loop! (make-ws-client nil))))

(defn init [{:keys [connect?]}]
  (when connect?
    (connect))
  !channel)
